export default __webpack_public_path__ + "static/media/le404.2bd4c5ce.png";